export enum TryingToConceiveStatus {
  FERTILE = 'fertile',
  LOW = 'low',
  HIGH = 'high',
  PEAK = 'peak',
  POST_OVULATION = 'post_ovulation',
  PERIOD = 'period',
}
